// 9fbef606107a605d69c0edbcd8029e5d
export const CHECKOUT_ORDERCONFIRMATION = 'checkout.orderConfirmation';
export const GLOBAL_HELPCENTER = 'global.helpCenter';

export const lblMoreHelpResendConfirmText = 'lbl_more_help_resend-confirm-text';

const HelpMenuLabels = {
  checkout: {
    orderConfirmation: {
      lbl_help_with_order_receipts: 'Receipts',
      lbl_help_with_order_modal_open: 'Order Help',
      [lblMoreHelpResendConfirmText]: 'Resend Order Confirmation',
    },
  },
  global: {
    helpCenter: {
      lbl_order_status_help_text: 'Contact Us About Your Order',
      lbl_overview_help: 'Help',
      lbl_more_help_return_policy_text: 'Return Policy',
      lbl_modal_initiate_return: 'Initiate Return',
    },
  },
};

export default HelpMenuLabels;
